import {
  type ValidatorFunction,
  type ValidatorResult,
} from 'ember-changeset-validations';
import { utcDate, isSameOrAfter } from 'uplisting-frontend/utils/date';

export function validateIsSameOrAfter(fieldName: string): ValidatorFunction {
  return (
    _key: string,
    newValue: unknown,
    _oldValue: unknown,
    changes: Record<string, unknown>,
    content: Record<string, unknown>,
  ): ValidatorResult => {
    const other = (changes[fieldName] ?? content[fieldName]) as Date;

    return isSameOrAfter(newValue as Date, other ?? utcDate(new Date()));
  };
}
